module.exports = __webpack_public_path__ + "img/burner-mining-drill-S-shadow.950bb65a.png";